import React, { useContext, useEffect, useRef } from 'react';
import { AuthContext } from '../context/Auth';
import { WindowManagerContext } from '../context/WindowManager';

function useOutsideAlerter (ref, onOutsideClick) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside (event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onOutsideClick();
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

const MenuButton = props => {
  return (
    <div
      style={{
        textDecoration: 'none',
        background: 'white',
        width: '100%',
        cursor: 'pointer',
        paddingTop: 12,
        paddingBottom: 12,
        paddingLeft: 8,
        paddingRight: 8,
        borderRadius: props.last ? '0px 0px 12px 12px' : 12,
        ...props.style
      }}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
};

const Menu = ({ close, ...props }) => {
  const small = window.innerWidth < 500;
  const { user, auth, logout } = useContext(AuthContext);
  const { openWindow } = useContext(WindowManagerContext);
  const width = small ? 250 : 350;
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, close);
  return (
    <>
      <div
        style={{
          top: props.top || 0,
          left: props.left || 0,
          zIndex: 1001,
          position: 'absolute',
          background: 'white',
          borderRadius: 12,
          width,
          boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.1)'
        }}
        ref={wrapperRef}
      >

        {
          auth.loggedIn
            ? (
              <>
                {/* <MenuButton onClick={()=>}>Dein Profil</MenuButton>
                <hr /> */}
                {
                  user.profileInformation?.phone && (
                    <MenuButton
                      onClick={() => props.openWizard()}
                      style={{ background: 'red', color: 'white', width }}
                    >
                      Wunschjob
                    </MenuButton>
                  )
                }
                <MenuButton onClick={() => { logout(); openWindow('login', { justLoggedOut: true }); }} style={{ background: 'red', color: 'white', width }}>Logout</MenuButton>
              </>
              )
            : (
              <>
                {/* <MenuButton onClick={() => openWindow('signup', { })} style={{ width }}>Registrieren</MenuButton> */}
                <MenuButton onClick={() => openWindow('login', { })} style={{ background: 'green', color: 'white', width }}>Einloggen</MenuButton>
              </>
              )
        }
      </div>
    </>
  );
};

export default Menu;
